<template>
  <div class="error-content" slot="error-page">
    <img class="error-img" src="../../assets/403.png" alt />
    <p class="p2">抱歉，您暂时没有权限访问该页面</p>
  </div>
</template>
<script>
export default {
  name: "NoAuthority",
  
  data() {
    return {
    };
  },
  methods: {},
  created() {
    
  }
};
</script>
<style lang="less">

.error-content {
  width: 450px;
  height: 260px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -225px;
  margin-top: -140px;
  text-align: center;

  .error-img {
    vertical-align: middle;
  }

  .p2 {
    font-size: 16px;
    color: #999;
    padding-top: 60px;
  }

  .error-text {
    height: 350px;
    display: inline-block;
    padding-left: 100px;
    vertical-align: middle;

    .p1 {
      font-size: 70px;
      padding-top: 90px;
    }

    .p2 {
      font-size: 20px;
    }
  }
}
</style>

